import { render, staticRenderFns } from "./PlainView.vue?vue&type=template&id=288cfc61&"
import script from "./PlainView.vue?vue&type=script&lang=js&"
export * from "./PlainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports